import { render, staticRenderFns } from "./VerDetalleModal.vue?vue&type=template&id=14f44964&scoped=true&"
import script from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleModal.vue?vue&type=script&lang=ts&"
import style0 from "./VerDetalleModal.vue?vue&type=style&index=0&id=14f44964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f44964",
  null
  
)

export default component.exports